import { Alert } from "@mui/material";
import { ModelSavingData } from "src/hooks/use-model-saving-data";

type DisplayErrorsProps = {
  savingData: ModelSavingData<any>,
  // for containers that already space their children (e.g. a Stack with gap)
  noMargin?: boolean
}

export default function DisplayErrors({ savingData, noMargin }: DisplayErrorsProps) {
  if (savingData.errors && savingData.errors.length) {
    return <Alert severity="error" sx={{ marginBottom: noMargin ? 0 : 2 }} >
      {savingData.errors.map((err, index) => <div key={index}>{err.message}</div>)}
    </Alert>
  }

  return null;
}